"use client";

export {
  default,
  Icon,
  ICON_SIZES,
  ICON_FLIP,
  ICON_ANIMATE,
  ICON_TYPE,
} from "@repo/ui/library/icon";
export type { IconNameExtended, IconProps } from "@repo/ui/library/icon";
